(function () {
  var STORAGE_KEY = 'contraband_site_promo_dismissed';

  function initSitePromoPopup() {
    var root = document.getElementById('site-promo-popup');
    if (!root) return;

    if (root.getAttribute('data-enabled') !== 'true') return;

    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
    } catch (e) {}

    var delaySec = parseInt(root.getAttribute('data-delay') || '10', 10);
    if (!delaySec || delaySec < 0) delaySec = 10;

    var backdrop = root.querySelector('[data-site-promo-close]');
    var closeButtons = root.querySelectorAll('[data-site-promo-close]');

    function lockScroll() {
      document.body.classList.add('overflow-hidden');
    }

    function unlockScroll() {
      document.body.classList.remove('overflow-hidden');
    }

    function openPopup() {
      root.hidden = false;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
    }

    function closePopup() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      unlockScroll();
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
      window.setTimeout(function () {
        root.hidden = true;
      }, 350);
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closePopup();
      }
    });

    window.setTimeout(openPopup, delaySec * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSitePromoPopup);
  } else {
    initSitePromoPopup();
  }
})();
